module.exports = __webpack_public_path__ + "static/media/icon-omnilogic-white.cdf4fca0.png";